/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TreatmentHistoryCategoryEnum } from './treatmentHistoryCategoryEnum';
import { AppointmentFormatEnum } from './appointmentFormatEnum';
import { AppointmentStatusEnum } from './appointmentStatusEnum';
import { TreatmentTypeEnum } from './treatmentTypeEnum';
import { TreatmentHistoryEntry } from './treatmentHistoryEntry';


/**
 * Appointment entry; ``children`` holds the entries documented against it.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentTreatmentHistoryEntry { 
    readonly category: TreatmentHistoryCategoryEnum;
    readonly key: string;
    readonly date: string;
    readonly therapistName: string | null;
    readonly children: Array<TreatmentHistoryEntry>;
    readonly appointmentId: number;
    readonly status: AppointmentStatusEnum;
    readonly appointmentTypeName: string;
    readonly isInitialConsultation: boolean;
    readonly appointmentFormat: AppointmentFormatEnum;
    readonly treatmentType: TreatmentTypeEnum;
    readonly practiceName: string;
}
export namespace AppointmentTreatmentHistoryEntry {
}

export const AppointmentTreatmentHistoryEntry_category_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_key_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_date_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_therapistName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_children_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_appointmentId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_status_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_appointmentTypeName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_isInitialConsultation_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_appointmentFormat_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_treatmentType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTreatmentHistoryEntry_practiceName_Validators: ValidatorFn[] =
    [  Validators.required, ];


